// extracted by mini-css-extract-plugin
export var btn = "SearchInput-module--btn--f9876";
export var form = "SearchInput-module--form--6372c";
export var input = "SearchInput-module--input--acf55";